import { constants, Defaults, JobType, Routing } from "@common/_constants/";
import { refetch, TrackingService, UserService } from "@common/_services";
import { Button } from "@common/components/Atoms/Button";
import ReferError from "@common/components/Atoms/Error";
import {
    FormHandler,
    Input,
    Rules,
    Select,
} from "@common/components/Atoms/FormInputs";
import { IconComment, IconEmail } from "@common/components/Atoms/Icons";
import FileDrop from "@common/components/Molecules/FileDrop";
import Modal from "@common/components/Molecules/Modal";
import { FormField, UserFromStorage } from "@common/models";
import { JobService, ReferralService } from "@pro/_services";
import qs from "qs";
import React from "react";

// import { ReferThankYou } from "@pro/containers/Modals/ReferThankYou"

interface ShareJobLinksProps {
    user: UserFromStorage;
    selectedJob?: JobFromResult;
    name: string;
    phone: string;
    email: string;
}

interface ShareJobLinksState {
    url: string;
    emailLink: string;
    facebookLink: string;
    linkedInLink: string;
    twitterLink: string;
}

class ShareJobLinks extends React.Component<
    ShareJobLinksProps,
    ShareJobLinksState
> {
    constructor(props: ShareJobLinksProps) {
        super(props);
        this.getJobShareLink = this.getJobShareLink.bind(this);
        this.state = {
            url: "",
            emailLink: "",
            facebookLink: "",
            linkedInLink: "",
            twitterLink: "",
        };
    }

    async componentDidMount() {
        await this.getJobShareLink();
    }

    getJobShareLink = async () => {
        const { selectedJob } = this.props;

        if (!selectedJob) return;

        const url = `${constants.GlobalConfig.apiUrl}/pro/v2/jobs/${selectedJob.item_id}/sharelinks`;

        const settings = {
            headers: {
                "Content-Type": "application/json",
            },
            method: "GET",
        };

        refetch(url, settings)
            .then(resp => resp.json())
            .then(json => {
                this.setState({
                    url: json.result.url,
                    emailLink: json.result.email_url,
                    facebookLink: json.result.facebook_url,
                    linkedInLink: json.result.linked_in_url,
                    twitterLink: json.result.twitter_url,
                });
            });
    };

    render() {
        const { user, selectedJob, name, phone, email } = this.props;
        const { url } = this.state;
        if (!selectedJob || !name || !phone || !email) return;

        const firstName = splitName(name)[0];

        const emailMessage = {
            subject: `Thought of you for ${selectedJob.item_name}`,
            body:
                `Hi ${firstName},\r\n\r\n` +
                `You were recommended for this job by ${user.firstName}.\r\n\r\n` +
                `${selectedJob.item_name}\r\n` +
                `${selectedJob.item_type}\r\n` +
                `${selectedJob.item_location}\r\n\r\n` +
                "Click below to view the details on this job or to learn about other job openings. You can also join Relode's referral program and earn rewards for connecting your network to great jobs. \r\n\r\n" +
                `${url}\r\n\r\n` +
                "Have a great day,\r\n" +
                "Team Relode",
        };

        const smsMessage = `${user.displayName} has found a job for which you may be a good fit. Check this and other jobs at: ${url}.`;

        const iOS =
            !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);

        return (
            <div className="c-block">
                <div className="c-control__label">
                    <div className="c-block">
                        <h1 className="c-block__title">
                            {selectedJob.item_name}
                        </h1>
                        <p className="u-text-gray">
                            {selectedJob.total_commission_in_us_dollars}{" "}
                            {selectedJob.total_commission_in_us_dollars !== ""
                                ? " referral reward"
                                : "referral reward not available"}
                        </p>
                    </div>
                    <label htmlFor="resumeDropZone">
                        Choose one of the options below to share the job:
                    </label>
                </div>
                <div className="c-control__wrapper">
                    {!iOS ? (
                        <Button
                            className="c-button u-margin-lg-top"
                            id="refer-pro-android-text-button"
                            block={true}
                            green={true}
                            onClick={() =>
                                (location.href = `sms:${phone}?body=${smsMessage}`)
                            }
                        >
                            <span className="u-float-left u-padding-icon-specific">
                                <IconComment />
                            </span>
                            <span className="u-align-btn-txt">{`text ${firstName}`}</span>
                        </Button>
                    ) : (
                        <Button
                            className="c-button u-margin-lg-top"
                            id="refer-pro-iphone-text-button"
                            block={true}
                            green={true}
                            onClick={() =>
                                (location.href = `sms:${phone}&body=${smsMessage}`)
                            }
                        >
                            <span className="u-float-left u-padding-icon-specific">
                                <IconComment />
                            </span>
                            <span className="u-align-btn-txt">{`text ${firstName}`}</span>
                        </Button>
                    )}

                    <Button
                        className="c-button u-margin-lg-top"
                        id="refer-pro-email-button"
                        block={true}
                        green={false}
                        onClick={() =>
                            (location.href = `mailto:${email}?${qs.stringify(
                                emailMessage
                            )}`)
                        }
                    >
                        <span className="u-float-left u-padding-icon-specific">
                            <IconEmail />
                        </span>
                        <span className="u-align-btn-txt">{`email ${firstName}`}</span>
                    </Button>
                </div>
            </div>
        );
    }
}

interface ContextJobModel {
    job_id: number;
    job_name: string;
    job_type: JobType;
    total_commission_in_us_dollars: string;
    location: string;
}

interface JobFromResult {
    item_id: number;
    item_name: string;
    item_type: JobType;
    total_commission_in_us_dollars: string;
    item_location: string;
}

interface ReferCandidateProps {
    isOpen: boolean;
    onOkay: (newJobCandidateId: number) => void;
    onCancel: () => void;
    closeModal: () => void;
    job?: ContextJobModel;
}

interface ReferCandidateState {
    error: boolean;
    processing: boolean;
    errorMessages: string[];
    resume: {
        isValid: boolean;
        resumeFileId?: number;
        resumeFile?: any;
        originalResumeFile?: any;
        validationMessages: string[];
    };
    doValidateFile: boolean;
    formIsValid: boolean;
    formFields: {
        job: FormField;
        name: FormField;
        phone: FormField;
        email: FormField;
    };

    selectedJob?: JobFromResult;
    jobSearchResults: JobFromResult[];

    user: UserFromStorage;
    currentStep: "info" | "resume" | "share";
}

export class ReferCandidate extends React.Component<
    ReferCandidateProps,
    ReferCandidateState
> {
    private _abortControllers: { [key: string]: AbortController } = {};

    constructor(props) {
        super(props);

        this.emptyState = this.emptyState.bind(this);
        this.getJobs = this.getJobs.bind(this);
        this.onCloseModal = this.onCloseModal.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.onFormFieldChange = this.onFormFieldChange.bind(this);

        this.handleResumeFileAdd = this.handleResumeFileAdd.bind(this);
        this.handleResumeFileRemove = this.handleResumeFileRemove.bind(this);
        this.handleResumeFileError = this.handleResumeFileError.bind(this);
        this.handleResumeFileUploading = this.handleResumeFileUploading.bind(
            this
        );
        this.handleResumeFileUploaded = this.handleResumeFileUploaded.bind(
            this
        );

        this.state = this.emptyState();
    }

    async componentWillReceiveProps(nextProps: ReferCandidateProps) {
        if (nextProps.job !== this.props.job) {
            this.setState({ selectedJob: this.setSelectedJob(nextProps.job) });
        }
    }

    componentWillUnmount() {
        const abortControllers = this._abortControllers;
        if (Object.keys(abortControllers).length > 0) {
            Object.keys(abortControllers).map(key =>
                abortControllers[key].abort()
            );
        }
    }

    setSelectedJob = (job?: ContextJobModel) => {
        return job
            ? {
                  item_id: job.job_id,
                  item_name: job.job_name,
                  item_location: job.location,
                  item_type: job.job_type,
                  total_commission_in_us_dollars:
                      job.total_commission_in_us_dollars,
              }
            : undefined;
    };
    async getJobs(term: string) {
        // Check to see if there already was an abortController, and if so, call abort on it
        if (this._abortControllers.suggest) {
            this._abortControllers.suggest.abort();
        }
        this._abortControllers.suggest = new AbortController();
        const signal = this._abortControllers.suggest.signal;

        try {
            const response = await JobService.suggest(term, signal);
            this.setState({ jobSearchResults: response.results });
            return response.results.map(r => ({
                label: r.item_name,
                value: r.item_id,
            }));
        } catch (error) {
            handleError(error, this);
        }
    }

    onCloseModal() {
        this.setState(this.emptyState(), this.props.closeModal);
    }

    onFormFieldChange(
        name: string,
        value: { label: string; value: string | number }
    ) {
        const formFields = this.state.formFields;
        FormHandler.handleInputChange(name, value, formFields);
        if (name === "job") {
            const selectedJob = this.state.jobSearchResults.find(job => {
                return job.item_id === value.value;
            });
            this.setState({ selectedJob });
        }
        this.setState({ formFields });
    }

    verifyEmailPhone = (e: any, nextStep: "share" | "resume") => {
        e.preventDefault();
        this.setState({ doValidateFile: true }, () => {
            const { formFields } = this.state;
            const candidateIsValid = FormHandler.validate(formFields);
            if (!candidateIsValid) {
                this.setState({ formFields, formIsValid: false, error: true });
            } else {
                const jobId = this.props.job
                    ? this.props.job.job_id
                    : this.state.formFields.job.value.value;

                let validationRequest = {
                    candidate_email: this.state.formFields.email.value,
                    candidate_phone: this.state.formFields.phone.value,
                    job_id: jobId,
                };

                validationRequest = TrackingService.addAttribution(
                    validationRequest
                );
                ReferralService.validate(validationRequest)
                    .then(() => {
                        this.setState({
                            error: false,
                            formIsValid: true,
                            errorMessages: [],
                            currentStep: nextStep,
                        });
                    })
                    .catch(err => handleError(err, this));
            }
        });
    };

    validateEntireForm() {
        const { formFields, currentStep } = this.state;
        let isValid = FormHandler.validate(formFields);

        isValid =
            currentStep === "resume"
                ? isValid && !!this.state.resume.resumeFileId
                : isValid;

        if (!isValid) {
            this.setState(prevState => {
                if (
                    currentStep === "resume" &&
                    !prevState.resume.resumeFileId
                ) {
                    const resume = {
                        ...prevState.resume,
                        isValid: false,
                        validationMessages: ["A resume upload is required"],
                    };
                    return { formFields, formIsValid: false, resume };
                }
                return {
                    formFields,
                    formIsValid: false,
                    resume: prevState.resume,
                };
            });
        } else {
            this.setState({
                formFields,
                formIsValid: true,
                error: false,
                currentStep: "resume",
            });
        }
        return isValid;
    }

    onSubmit(e: any) {
        e.preventDefault();
        this.setState({ doValidateFile: true }, () => {
            const { formFields } = this.state;
            const isValid = this.validateEntireForm();
            if (isValid) {
                this.setState(
                    { formFields, formIsValid: true, processing: true },
                    () => {
                        const jobId = this.props.job
                            ? this.props.job.job_id
                            : this.state.formFields.job.value.value;
                        const name = splitName(
                            this.state.formFields.name.value
                        );
                        const candidate = {
                            is_apply: false,
                            job_id: jobId,
                            candidate_first_name: name[0],
                            candidate_last_name: name[1],
                            candidate_email: this.state.formFields.email.value,
                            candidate_phone: this.state.formFields.phone.value,
                            candidate_resume_file_id: this.state.resume
                                .resumeFileId,
                        };

                        ReferralService.refer(candidate)
                            .then(candidateResult => {
                                this.setState(this.emptyState, () =>
                                    this.props.onOkay(
                                        candidateResult.job_candidate_id
                                    )
                                );
                            })
                            .catch(err => handleError(err, this));
                    }
                );
            }
        });
    }

    handleResumeFileAdd(fileId: number) {
        const resume = {
            ...this.state.resume,
            resumeFileId: fileId,
            isValid: true,
        };
        this.setState({ resume });
    }

    handleResumeFileRemove(fileId: number) {
        const resume = { ...this.state.resume, resumeFileId: undefined };
        this.setState({ resume });
    }

    handleResumeFileError(errorMsg: string) {
        this.setState({ processing: false });
        const resume = {
            ...this.state.resume,
            validationMessages: [errorMsg],
            isValid: false,
        };
        this.setState({ resume });
    }

    handleResumeFileUploading() {
        this.setState({ processing: true });
    }

    handleResumeFileUploaded() {
        this.setState({ processing: false });
    }

    getUser() {
        let user = UserService.getUserFromStorage();
        if (!user) {
            user = {
                displayName: "",
                firstName: "",
                profileImageUrl: "",
                token: "",
                email: "",
                expires: 0,
                roleId: 0,
                applicationName: "",
            };
        }
        return user;
    }

    emptyState(): ReferCandidateState {
        const requireJobUnlessJobPropExists = (
            field: FormField,
            fieldset?: FormField[]
        ) => !!this.props.job || Rules.required(field, fieldset);

        return {
            selectedJob: this.setSelectedJob(this.props.job),
            error: false,
            processing: false,
            errorMessages: [],
            resume: {
                isValid: true,
                resumeFileId: undefined,
                resumeFile: undefined,
                originalResumeFile: undefined,
                validationMessages: [] as string[],
            },
            doValidateFile: false,
            formIsValid: true,
            formFields: {
                job: {
                    name: "job",
                    value: "",
                    label: "",
                    isValid: true,
                    validationMessages: [] as string[],
                    rules: [requireJobUnlessJobPropExists],
                },
                name: {
                    name: "name",
                    value: "",
                    label: "",
                    isValid: true,
                    validationMessages: [] as string[],
                    rules: [Rules.required, Rules.formatApplyName],
                },
                email: {
                    name: "email",
                    value: "",
                    label: "",
                    isValid: true,
                    validationMessages: [] as string[],
                    rules: [Rules.required, Rules.formatEmail],
                },
                phone: {
                    name: "phone",
                    value: "",
                    label: "",
                    isValid: true,
                    validationMessages: [] as string[],
                    rules: [Rules.required, Rules.formatPhone],
                },
            },

            jobSearchResults: [],
            user: this.getUser(),
            currentStep: "info",
        };
    }

    render() {
        const jobDisplay = this.props.job ? (
            <div className="c-block">
                <h1 className="c-block__title">{this.props.job.job_name}</h1>
                <p className="u-text-gray">
                    {this.props.job.total_commission_in_us_dollars}{" "}
                    {this.props.job.total_commission_in_us_dollars !== ""
                        ? " referral reward"
                        : "referral reward not available"}
                </p>
            </div>
        ) : (
            <div className="c-block">
                <Select
                    name="job"
                    label="search jobs"
                    value={this.state.formFields.job.value}
                    multi={false}
                    isValid={this.state.formFields.job.isValid}
                    validationMessages={
                        this.state.formFields.job.validationMessages
                    }
                    onChange={this.onFormFieldChange}
                    remoteOptionsMethod={this.getJobs}
                />
            </div>
        );

        const legal = (
            <div className="c-block u-text-legal">
                By referring a candidate for this position, you agree to our{" "}
                <a
                    className="c-link c-link--magenta"
                    target="_blank"
                    href={Routing.Marketing.POLICY_TERMS}
                >
                    Terms of Use
                </a>
                . You have agreed to introduce Relode with the above candidate
                who is interested and aware of this specific position. Upon hire
                of a Qualified Candidate, you will be paid the specified reward
                (Success Fee) pursuant to our Terms of Use.
            </div>
        );

        const referError = (
            <ReferError
                show={!this.state.formIsValid || this.state.error}
                description={
                    this.state.errorMessages && this.state.errorMessages.length
                        ? this.state.errorMessages[0]
                        : ""
                }
            />
        );

        const { currentStep } = this.state;

        return (
            <Modal
                size="xs"
                title="refer a candidate"
                isOpen={this.props.isOpen}
                closeModal={this.onCloseModal}
                loading={this.state.processing}
            >
                <form onSubmit={this.onSubmit}>
                    {currentStep === "info" ? (
                        <>
                            {jobDisplay}
                            <Input
                                type="text"
                                name="name"
                                label="candidate's name"
                                value={this.state.formFields.name.value}
                                isValid={this.state.formFields.name.isValid}
                                validationMessages={
                                    this.state.formFields.name
                                        .validationMessages
                                }
                                onChange={this.onFormFieldChange}
                            />

                            <Input
                                type="text"
                                name="email"
                                label="candidate's email"
                                value={this.state.formFields.email.value}
                                isValid={this.state.formFields.email.isValid}
                                validationMessages={
                                    this.state.formFields.email
                                        .validationMessages
                                }
                                onChange={this.onFormFieldChange}
                            />

                            <Input
                                type="tel"
                                name="phone"
                                label="candidate's phone"
                                value={this.state.formFields.phone.value}
                                isValid={this.state.formFields.phone.isValid}
                                validationMessages={
                                    this.state.formFields.phone
                                        .validationMessages
                                }
                                onChange={this.onFormFieldChange}
                            />

                            <div className="c-block">
                                {referError}

                                <div className="c-control__label">
                                    <label htmlFor="resumeDropZone">
                                        do you have the candidate’s resume?
                                    </label>
                                </div>
                                <div className="c-control__wrapper">
                                    <Button
                                        className="c-button u-margin-lg-top"
                                        id="refer-yes-button"
                                        green={true}
                                        block={true}
                                        type="submit"
                                        onClick={e => {
                                            this.verifyEmailPhone(e, "resume");
                                        }}
                                    >
                                        yes
                                    </Button>

                                    <Button
                                        className="c-button u-margin-lg-top"
                                        id="refer-no-button"
                                        green={true}
                                        block={true}
                                        type="submit"
                                        onClick={e => {
                                            this.verifyEmailPhone(e, "share");
                                        }}
                                    >
                                        no
                                    </Button>
                                </div>
                            </div>
                        </>
                    ) : null}

                    {currentStep === "resume" ? (
                        <>
                            <div className="c-block">
                                <div className="c-control__label">
                                    {jobDisplay}
                                    <label htmlFor="resumeDropZone">
                                        candidate's resume
                                    </label>
                                </div>
                                <div className="c-control__wrapper">
                                    <FileDrop
                                        name="resumeDropZone"
                                        isMultiple={false}
                                        handleAdd={this.handleResumeFileAdd}
                                        handleRemove={
                                            this.handleResumeFileRemove
                                        }
                                        onFileError={this.handleResumeFileError}
                                        onFileUploading={
                                            this.handleResumeFileUploading
                                        }
                                        onFileUploaded={
                                            this.handleResumeFileUploaded
                                        }
                                        isValid={this.state.resume.isValid}
                                        validationMessages={
                                            this.state.resume.validationMessages
                                        }
                                        fileCategory={
                                            Defaults.FileCategoryType
                                                .OriginalResume
                                        }
                                        acceptedFiles={
                                            ".doc,.docx,.pdf,.rtf,.txt,.rtf,.html,.htm"
                                        }
                                    />
                                </div>
                            </div>

                            <div className="c-block">
                                {referError}

                                <Button
                                    id="refer-submit-referral-button"
                                    block={true}
                                    green={true}
                                    type="submit"
                                    onClick={this.onSubmit}
                                >
                                    submit referral
                                </Button>
                            </div>

                            {legal}
                        </>
                    ) : null}

                    {currentStep === "share" ? (
                        <>
                            <ShareJobLinks
                                user={this.state.user}
                                selectedJob={this.state.selectedJob}
                                name={this.state.formFields.name.value}
                                phone={this.state.formFields.phone.value}
                                email={this.state.formFields.email.value}
                            />
                            {legal}
                        </>
                    ) : null}
                </form>
            </Modal>
        );
    }
}

// Helpers...
function splitName(name: string) {
    if (!name) {
        throw new Error("Name must be a non-empty string");
    }

    const lastSpaceIndex = name.lastIndexOf(" ");
    if (lastSpaceIndex === -1) {
        return [name, ""];
    }

    return [
        name.substring(0, lastSpaceIndex),
        name.substring(lastSpaceIndex + 1, name.length),
    ];
}

function handleError(err, stateContainer) {
    if (err.type === "abort" || err.name === "AbortError") {
        stateContainer.setState({ processing: false });
        return;
    }

    const messages = err.responseData
        ? err.responseData.error_messages
        : [err.message];

    stateContainer.setState({
        error: true,
        errorMessages: messages,
        processing: false,
    });
}
